import React from 'react';

import { getMyAssessmentsProps } from 'router/seoprops/pages/assessments';
import { NextSeo } from 'next-seo';

import { useQuery } from 'react-query';
import { QueryClient, dehydrate } from 'react-query';
import { GetAllAssessments } from 'services/core';
import Spinner from '@core/components/spinner/Spinner';
import AssessmentCard from 'components/pages/assessments/assessmentcard/AssessmentCard';

import classes from './my-assessments.module.scss';

const index = () => {

    const seoProps = getMyAssessmentsProps();
    const { data, isLoading } = useQuery(['assessments'], GetAllAssessments);

    return (
        <>
            <NextSeo {...seoProps} />
            <div className='container'>
                <div className={classes['wrapper']}>
                    <div className={classes['assessments-header']}>
                        <h1>Explore Assessments</h1>
                        <p>Pick a free assessment, test your skills, and get feedback plus course recommendations.</p>
                    </div>
                    {(data && !isLoading) && (
                        <div className={classes['assessments-card-wrapper']}>
                            {data?.data.map((assessment, index) => (
                                <AssessmentCard key={index} data={assessment} isSmall={true} />
                            ))}
                        </div>
                    )}
                    {isLoading && (
                        <div className={classes['loading']}>
                            <Spinner />
                        </div>
                    )}
                </div>
            </div>

        </>
    );
};

export default index;